import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/royce/web/speakers/jay/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/royce/web/speakers/jay/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import "core-js/modules/es6.object.assign";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from "react";
import { Box } from "theme-ui";
import parseResponsiveProp from "../lib/parseResponsiveProp";
var layout = ["static", "relative", "absolute", "fixed"];
var visibility = ["none", "block"];
var fill = ["auto", "100%"];
export default function Section(_ref) {
  var l = _ref.l,
      v = _ref.v,
      f = _ref.f,
      w = _ref.w,
      mw = _ref.mw,
      h = _ref.h,
      sx = _ref.sx,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["l", "v", "f", "w", "mw", "h", "sx", "children"]);

  l = parseResponsiveProp(l, layout);
  v = parseResponsiveProp(v, visibility);
  f = parseResponsiveProp(f, fill);
  return /*#__PURE__*/React.createElement(Box, _extends({
    as: "section",
    __themeKey: "sections",
    sx: _objectSpread({
      width: f,
      maxWidth: mw,
      height: h,
      display: v,
      position: l
    }, sx)
  }, rest), children);
}